import './RoundedButton.scss';

const RoundedButton = ({ text, onClick, showArrow }) => {
  return (
    <button className="rounded-button" onClick={onClick}>
      <p className='button-text'>
        {text}
        </p>
      {showArrow && <img src="assets/icons/arrow-down.svg" alt="Arrow Down" />}
    </button>
  );
};

export default RoundedButton;